import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// First path segment → page: the same table the API uses to write each page's head (meu-treino-api src/seo/pages.js)
const PAGE_OF_ROUTE = {
  '': 'home',
  login: 'login',
  dashboard: 'dashboard',
  workouts: 'workouts',
  workout: 'workouts',
  'split-review': 'workouts',
  execute: 'session',
  progress: 'progress',
  diet: 'diet',
  'calorie-tracker': 'calories',
  exercises: 'exercises',
  academy: 'academy',
  sync: 'sync',
  plans: 'plans',
  account: 'account',
  terms: 'terms',
  privacy: 'privacy',
  'reset-password': 'reset',
};

// A first segment the app has no page for is the "not found" page (the server answers it with a 404)
export const pageOfPath = (pathname) => {
  const first = (pathname.split('/')[1] || '').toLowerCase();
  return Object.hasOwn(PAGE_OF_ROUTE, first) ? PAGE_OF_ROUTE[first] : 'notFound';
};

/** The tab title of a path: the home page's already names the site; the others end with it. */
export const titleOfPath = (pathname, t) => {
  const page = pageOfPath(pathname);
  const title = t(`pageTitles.${page}`);
  return page === 'home' ? title : `${title} · ${t('appName')}`;
};

/** Keeps the tab title in step with the route; the server writes the same one into the first load. */
export const usePageTitle = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    document.title = titleOfPath(pathname, t);
  }, [pathname, t]);
};
